module.exports = __webpack_public_path__ + "img/03_add_12px_12px.fe5c3966.png";